export const types = {

    SET_LOCALE: 'LOCALIZATION_SET_LOCALE',

    SEND_LOCALE_REQUEST: 'LOCALIZATION_SEND_LOCALE_REQUEST',
    SEND_LOCALE_SUCCESS: 'LOCALIZATION_SEND_LOCALE_SUCCESS',
    SEND_LOCALE_FAILURE: 'LOCALIZATION_SEND_LOCALE_FAILURE',
};